// extracted by mini-css-extract-plugin
export default {"arrowIconLeft":"styles_arrowIconLeft__S6Azc","arrowIconRight":"styles_arrowIconRight__duvF+"};